import allCountries from '@/settings/scripts/all-country'

const getters = {
  getUniversityName (state) {
    return state.university ? state.university.name.split(' ').join() : false
  },
  getUniversityNameUpper (state) {
    let splitStr = state.university ? state.university.name.toLowerCase().split(' ') : ''
    for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
    }
    return splitStr ? splitStr.join(' ') : splitStr
  },
  getUniversities (state) {
    return state.universities
  },
  getUniversitiesLabels (state) {
    let listUniversities = []
    for (let i = 0; i < state.universities.length; i++) {
      const element = state.universities[i]
      let nameCountry = ''
      allCountries.forEach((item: any) => {
        if (item.country_code === element.country_code) {
          nameCountry = item.name
        }
      })
      if (listUniversities.length === 0) {
        listUniversities.push({
          country: nameCountry,
          code: element.country_code,
          info: [element]
        })
      } else {
        let validationCountry = listUniversities.findIndex((e:any) => e.code === element.country_code)
        if (validationCountry !== -1) {
          listUniversities[validationCountry].info.push(element)
        } else {
          listUniversities.push({
            country: nameCountry,
            code: element.country_code,
            info: [element]
          })
        }
      }
    }
    return listUniversities
  },
  getMercadilloU (state) {
    return state.mercadillo
  },
  getBanners (state) {
    return state.banners
  }
}

export default getters
